<template>
  <div class="topDiv">
    <div style="width:10px;height:5px"></div>
    <div class="news">
      <el-row class="menu">
        <el-col :span="3">
          <div style="width:160px;text-align:left;padding-left:28px;border-radius:5px 0px 0px 0px;" @click="changeClass(3)">
            <span>系统通知</span>
          </div>
        </el-col>
        <el-col :span="3" v-if="userInfo.userType == 'disabled' ">
          <div :class="{activeColor: menuIndex === 2 }" style="width:160px;line-height:50px;" @click="changeClass(2)">
            <span>最新职位</span>
          </div>
        </el-col>
        <!-- <el-col :span="3">
          <div :class="{activeColor: menuIndex === 1 }" style="width:160px;line-height:50px;" @click="changeClass(1)">
            <span>招聘会</span>
          </div>
        </el-col> -->
      </el-row>
      
      <el-row v-if="menuIndex==3" class="newsPaper">
        <el-col v-for="item in notice_arr">
          <SystemMessage :item="item" @click.native="goToNoticeDetail(item)"/>
        </el-col>
        <el-col>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageNoticeSize"
            :total="noticeTotalSize"
            :hide-on-single-page="true"
            @current-change="pageNoticeChange"
            @prev-click="pageNoticeChange"
            @next-click="pageNoticeChange"
            v-if="notice_arr.length > 0">
          </el-pagination>
        </el-col>
      </el-row>

      <el-row v-if="menuIndex==2" class="newsPaper" style="padding-bottom:20px">
        <el-col class="newItemPosi" style="margin-bottom:15px" v-for="item in jobs_arr">
          <PcNewPosition :item="item"/>
        </el-col>
        <el-col>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="totalSize"
            :hide-on-single-page="true"
            @current-change="pageChange"
            @prev-click="pageChange"
            @next-click="pageChange"
            v-if="jobs_arr.length > 0">
          </el-pagination>
        </el-col>
      </el-row>

      <el-row v-if="menuIndex==1" class="newsPaper">
        <div style="display:flex;jusity-content:flex-start;flex-wrap:wrap;margin-bottom:24px;background:white">
          <!-- <JobFairComp v-for="item in fairs_arr" :item="item" style="background:white"/> -->
        </div>
        <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="totalFairSize"
            :hide-on-single-page="true"
            @current-change="pageFairChange"
            @prev-click="pageFairChange"
            @next-click="pageFairChange">
        </el-pagination>
      </el-row>
      
    </div>
    <div style="width:10px;height:32px"></div>
  </div>
</template>
<script>
// import JobFairComp from "../components/JobFairComp.vue";
import SystemMessage from "@/components/SystemMessage.vue";
import PcNewPosition from "@/components/PcNewPosition.vue";
import { getAction , postAction , putAction} from '@/comm/manage';
import Vue from "vue";

export default {
  name: "",
  components: {
    SystemMessage,
    PcNewPosition,
    // JobFairComp
  },
  data() {
    return {
      searchWord: "",
      menuIndex: 3,
      pageSize : 3,
      pageNoticeSize: 10,
      curPage : 0,
      totalSize: 0,
      noticeTotalSize:0,
      searchParam:{},
      notice_arr:[],
      jobs_arr:[],
      fairs_arr:[],
      totalFairSize:0,
      url:{
        list:'/sys/annountCement/sysAnnlist',
        jobList:'/position/tsCompanyPosition/jobList',
        fairList:'/tsjobfair/tsJobFair/list'
      },
      userInfo:{}
    };
  },
  created(){
    this.userInfo = this.$store.state.users.userInfo;
    console.log(this.userInfo)
    // Vue.ls.get("Access_rain-Token");//token
    // Vue.ls.get("Login_Username");//时间戳
    // Vue.ls.get("Login_Userinfo");// 用户信息
    if(this.userInfo != null && this.userInfo.userType == "disabled"){
      let params = { delFlag:"0",msgType:"UC,ALLD,DISABLED" ,pageNo:0,pageSize:this.pageNoticeSize}
      this.loadNotices(params);
    }else if(this.userInfo != null && this.userInfo.userType == "company"){
      let params = { delFlag:"0",msgType:"UC,ALLC,COMPANY" ,pageNo:0,pageSize:this.pageNoticeSize}
      this.loadNotices(params);
    }
    this.searchParam = {curPage:this.curPage,
                         pageSize: this.pageSize};
    this.loadJobLists(this.searchParam);

    let param = {};
    param.pageNo = 0;
    param.pageSize = this.pageSize;
    this.loadJobFairLists(param);
  },
  methods: {
    changeClass(index) {
      this.menuIndex = index;
    },
    pageChange(val){
        this.searchParam.curPage = (val-1) * this.pageSize;
        this.searchParam.pageSize = this.pageSize;
        this.loadJobLists();
    },
    pageNoticeChange(val){
      let param = {delFlag:"0",msgType:"UC,ALLD,DISABLED"};
      param.pageNo = (val-1) * this.pageNoticeSize;
      param.pageSize = this.pageNoticeSize;
      this.loadNotices(param);
    },
    loadNotices(params){
      getAction(this.url.list,params).then(res=>{
          if(res.success){
            this.notice_arr = [];
            this.notice_arr = res.result.records;
            this.noticeTotalSize = res.result.total;
          }else{
            this.$message.warning(res.message);
          }
      })
    },
    loadJobLists(){
      getAction(this.url.jobList, this.searchParam).then((res) => {
        if (res.success) {
            this.jobs_arr = res.result;
            this.totalSize = res.total;
        }
        if (res.code === 510) {
            this.$message.warning(res.message);
        }
      });
    },
    loadJobFairLists(params){
      getAction(this.url.fairList, params).then((res) => {
        if (res.success) {
          this.fairs_arr = res.result.records;
          this.totalFairSize = res.result.total;
        }
        if (res.code === 510) {
            this.$message.warning(res.message);
        }
      });
    },
    pageFairChange(val){
      let searchParam = {};
      searchParam.pageNo = val;
      searchParam.pageSize = this.pageSize;
      this.loadJobFairLists(searchParam);
    },
    goToNoticeDetail(item){
      // this.$router.push('/pcMessageDetail');
      // this.$store.commit('SET_CURRENTNOTICEITEM',item);

      const { href } = this.$router.resolve({
        path: `./pcMessageDetail`,
        query: { id: item.id}
      });
      window.open(href, "_blank");
    }
  }
};
</script>
<style lang="stylus" scoped>
.topDiv {
  width: 100%;
  background-color: #f7f7f7;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  .topBanner {
    width: 100%;
    
    height: 94px;
    box-shadow: 0px 12px 10px 0px rgba(0, 0, 0, 0.03);

    .search {
      width: 1200px;
      margin: 0 auto;

      .zixun {
        margin: 26px 0 10px 0;
        font-size: 34px;
        font-family: YouSheBiaoTiHei;
        color: #f82b18;
        line-height: 44px;
      }

      .searchInput {
        margin: 26px 0 10px 0;

        .null-input >>> .el-input__inner {
          background-color: #F0F0F0;
          color: #525661;
          font-size: 16px;
          font-weight: 400;
          height: 45px;
        }

        .btnSearch {
          background-color: #f82b18;
          color: white;
          font-size: 20px;
          font-weight: 500;
          width: 140px;
          height: 45px;
        }
      }
    }

    .topSearch {
      margin: 26px 0 10px 0;
      background-color: #f82b18;
      color: white;
      font-size: 20px;
      font-weight: 400;
      width: 140px;
      height: 40px;
      line-height: 40px;
      margin-left: 40px;
      text-align: center;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  .news {
    width: 1200px;
    margin: 0 auto;
    background: white;

    .menu {
      background: #f82b18;
      margin-top: 32px;
      display: flex;
      justify: center;
      align-items: center;
      border-radius 6px 6px 0px 0px;
      height: 50px;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
      font-weight: 400;
      font-size: 15px;
      color: #fff;

      .activeColor {
        color: #f82b18;
        font-weight: bold;
        line-height: 50px;
        background-color: #fff;
      }
      div{
        cursor: pointer;
      }
      span {
        
      }
    }

    .newsPaper {
      // margin-top: 78px;
      padding-bottom 20px;
      .newItem {
        margin: 22px 0 0px 0;
      }

      .newItemPosi {
        margin: 22px 0 0px 0;
      }
    }
  }
}
</style>